"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFbUserRecordDTO = exports.FbUserRecordDTOSchema = exports.ajv = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-var-requires */ /* tslint:disable */
// generated by typescript-json-validator
const util_1 = require("util");
const ajv_1 = tslib_1.__importDefault(require("ajv"));
exports.ajv = new ajv_1.default({
    allErrors: true,
    coerceTypes: false,
    format: "fast",
    nullable: true,
    unicode: true,
    uniqueItems: true,
    useDefaults: true,
});
exports.ajv.addMetaSchema(require("ajv/lib/refs/json-schema-draft-06.json"));
exports.FbUserRecordDTOSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    defaultProperties: [],
    definitions: {
        "auth.MultiFactorInfo": {
            defaultProperties: [],
            description: "Interface representing the common properties of a user enrolled second factor.",
            properties: {
                displayName: {
                    description: "The optional display name of the enrolled second factor.",
                    title: "displayName",
                    type: "string",
                },
                enrollmentTime: {
                    description: "The optional date the second factor was enrolled, formatted as a UTC string.",
                    title: "enrollmentTime",
                    type: "string",
                },
                factorId: {
                    description: "The type identifier of the second factor. For SMS second factors, this is `phone`.",
                    title: "factorId",
                    type: "string",
                },
                uid: {
                    description: "The ID of the enrolled second factor. This ID is unique to the user.",
                    title: "uid",
                    type: "string",
                },
            },
            propertyOrder: ["uid", "displayName", "enrollmentTime", "factorId", "toJSON"],
            required: ["factorId", "uid"],
            title: "auth.MultiFactorInfo",
            type: "object",
        },
        "auth.MultiFactorSettings": {
            defaultProperties: [],
            description: "The multi-factor related user settings.",
            properties: {
                enrolledFactors: {
                    description: "List of second factors enrolled with the current user.\nCurrently only phone second factors are supported.",
                    items: {
                        $ref: "#/definitions/auth.MultiFactorInfo",
                    },
                    title: "enrolledFactors",
                    type: "array",
                },
            },
            propertyOrder: ["enrolledFactors", "toJSON"],
            required: ["enrolledFactors"],
            title: "auth.MultiFactorSettings",
            type: "object",
        },
        "auth.UserInfo": {
            defaultProperties: [],
            description: "Interface representing a user's info from a third-party identity provider\nsuch as Google or Facebook.",
            properties: {
                displayName: {
                    description: "The display name for the linked provider.",
                    title: "displayName",
                    type: "string",
                },
                email: {
                    description: "The email for the linked provider.",
                    title: "email",
                    type: "string",
                },
                phoneNumber: {
                    description: "The phone number for the linked provider.",
                    title: "phoneNumber",
                    type: "string",
                },
                photoURL: {
                    description: "The photo URL for the linked provider.",
                    title: "photoURL",
                    type: "string",
                },
                providerId: {
                    description: 'The linked provider ID (for example, "google.com" for the Google provider).',
                    title: "providerId",
                    type: "string",
                },
                uid: {
                    description: "The user identifier for the linked provider.",
                    title: "uid",
                    type: "string",
                },
            },
            propertyOrder: ["uid", "displayName", "email", "phoneNumber", "photoURL", "providerId", "toJSON"],
            required: ["displayName", "email", "phoneNumber", "photoURL", "providerId", "uid"],
            title: "auth.UserInfo",
            type: "object",
        },
        "auth.UserMetadata": {
            defaultProperties: [],
            description: "Interface representing a user's metadata.",
            properties: {
                creationTime: {
                    description: "The date the user was created, formatted as a UTC string.",
                    title: "creationTime",
                    type: "string",
                },
                lastRefreshTime: {
                    description: "The time at which the user was last active (ID token refreshed),\nformatted as a UTC Date string (eg 'Sat, 03 Feb 2001 04:05:06 GMT').\nReturns null if the user was never active.",
                    title: "lastRefreshTime",
                    type: "string",
                },
                lastSignInTime: {
                    description: "The date the user last signed in, formatted as a UTC string.",
                    title: "lastSignInTime",
                    type: "string",
                },
            },
            propertyOrder: ["lastSignInTime", "creationTime", "lastRefreshTime", "toJSON"],
            required: ["creationTime", "lastSignInTime"],
            title: "auth.UserMetadata",
            type: "object",
        },
    },
    description: "Interface representing a user.",
    properties: {
        customClaims: {
            additionalProperties: {},
            defaultProperties: [],
            description: "The user's custom claims object if available, typically used to define\nuser roles and propagated to an authenticated user's ID token.\nThis is set via\n{@link auth.Auth.setCustomUserClaims `setCustomUserClaims()`}",
            propertyOrder: [],
            title: "customClaims",
            type: "object",
        },
        disabled: {
            description: "Whether or not the user is disabled: `true` for disabled; `false` for\nenabled.",
            title: "disabled",
            type: "boolean",
        },
        displayName: {
            description: "The user's display name.",
            title: "displayName",
            type: "string",
        },
        email: {
            description: "The user's primary email, if set.",
            title: "email",
            type: "string",
        },
        emailVerified: {
            description: "Whether or not the user's primary email is verified.",
            title: "emailVerified",
            type: "boolean",
        },
        metadata: {
            $ref: "#/definitions/auth.UserMetadata",
            description: "Additional metadata about the user.",
            title: "metadata",
        },
        multiFactor: {
            $ref: "#/definitions/auth.MultiFactorSettings",
            description: "The multi-factor related properties for the current user, if available.",
            title: "multiFactor",
        },
        passwordHash: {
            description: "The user's hashed password (base64-encoded), only if Firebase Auth hashing\nalgorithm (SCRYPT) is used. If a different hashing algorithm had been used\nwhen uploading this user, as is typical when migrating from another Auth\nsystem, this will be an empty string. If no password is set, this is\nnull. This is only available when the user is obtained from\n{@link auth.Auth.listUsers `listUsers()`}.",
            title: "passwordHash",
            type: "string",
        },
        passwordSalt: {
            description: "The user's password salt (base64-encoded), only if Firebase Auth hashing\nalgorithm (SCRYPT) is used. If a different hashing algorithm had been used to\nupload this user, typical when migrating from another Auth system, this will\nbe an empty string. If no password is set, this is null. This is only\navailable when the user is obtained from\n{@link auth.Auth.listUsers `listUsers()`}.",
            title: "passwordSalt",
            type: "string",
        },
        phoneNumber: {
            description: "The user's primary phone number, if set.",
            title: "phoneNumber",
            type: "string",
        },
        photoURL: {
            description: "The user's photo URL.",
            title: "photoURL",
            type: "string",
        },
        providerData: {
            description: "An array of providers (for example, Google, Facebook) linked to the user.",
            items: {
                $ref: "#/definitions/auth.UserInfo",
            },
            title: "providerData",
            type: "array",
        },
        tenantId: {
            description: "The ID of the tenant the user belongs to, if available.",
            title: "tenantId",
            type: "string",
        },
        tokensValidAfterTime: {
            description: "The date the user's tokens are valid after, formatted as a UTC string.\nThis is updated every time the user's refresh token are revoked either\nfrom the {@link auth.Auth.revokeRefreshTokens `revokeRefreshTokens()`}\nAPI or from the Firebase Auth backend on big account changes (password\nresets, password or email updates, etc).",
            title: "tokensValidAfterTime",
            type: "string",
        },
        uid: {
            description: "The user's `uid`.",
            title: "uid",
            type: "string",
        },
    },
    propertyOrder: [
        "uid",
        "email",
        "emailVerified",
        "displayName",
        "phoneNumber",
        "photoURL",
        "disabled",
        "metadata",
        "providerData",
        "passwordHash",
        "passwordSalt",
        "customClaims",
        "tokensValidAfterTime",
        "tenantId",
        "multiFactor",
        "toJSON",
    ],
    required: ["disabled", "emailVerified", "metadata", "providerData", "uid"],
    type: "object",
};
exports.isFbUserRecordDTO = exports.ajv.compile(exports.FbUserRecordDTOSchema);
function validate(value) {
    if (exports.isFbUserRecordDTO(value)) {
        return value;
    }
    else {
        throw new Error(exports.ajv.errorsText(exports.isFbUserRecordDTO.errors.filter((e) => e.keyword !== "if"), { dataVar: "FbUserRecordDTO" }) +
            "\n\n" +
            util_1.inspect(value));
    }
}
exports.default = validate;
//# sourceMappingURL=FbUserRecord.validator.js.map